import React,
	{useState} 
from 'react';	
import './style.scss'
import { checkGlueJobExist } from 'src/utilities/AppSyncPlusAPIs';
import {
    Input,
} from "@amzn/awsui-components-react";
import './style.scss'


const FlexicoInput = ({value, index, onEdit, enterHintComponent, glueJobNotFoundComponent, glueJobLoadingComponent, isCriticalData, setErrorMessage}) =>{


    const [glueJobExistError, setGlueJobExistError] = useState(false)
    const [glueJobAPILoading, setGlueJobAPILoading] = useState(false)

	return (
		<>
            <Input
                // ref={input => {
                //     if (glueJobExistError && input) {
                //         input.focus();
                //     }
                // }}
                onChange={({ detail }) => {
                    let val = detail.value
                    if (value?.field_type == 'numeric_up_down') {
                        val = val.replace(/[^0-9]/g, '')
                    }
                    setGlueJobExistError(false)
                    onEdit({ label: val, dismissLabel: val }, index, 'typed_value')
                }}
                onKeyDown={({ detail }) => {
                    if (detail.key == 'Enter') {
                        if (value['typed_value'] == undefined || value['typed_value']?.label == undefined || value['typed_value']?.label == '') return
                        // Perform glue job validation only if the input field is contico_job
                        if(value?.label === "contico_job"){
                            setGlueJobAPILoading(true)
                            value['typed_value']['label'] = value['typed_value']?.label?.trim()
                            value['typed_value']['dismissLabel'] = value['typed_value']?.dismissLabel?.trim()
                            checkGlueJobExist(value['typed_value']['label'], isCriticalData? 'true': 'false', function onSuccess(result) {
                                    if(result?.data?.checkGlueJobExist?.status === 'true'){
                                        value['field_tokens'].push(value['typed_value'])
                                        onEdit(undefined, index, 'typed_value')
                                    }else{
                                        setGlueJobExistError(true)
                                    }
                                    setGlueJobAPILoading(false)
                                }, function onFailure(error) {
                                    setErrorMessage(error?.errors[0]?.message)
                                    // setShowLoadingIcon(false)
                                    setGlueJobAPILoading(false)
                            })
                        }else{
                            value['field_tokens'].push(value['typed_value'])
                            onEdit(undefined, index, 'typed_value')
                        }
                    }
                }}
                placeholder="values"
                value={value?.typed_value?.label}
                disabled={(value?.field_type == 'input' ? true : value?.field_type == 'numeric_up_down' ? (value['field_tokens']?.length >= 1) : (value.limit && value['field_tokens']?.length >= value.limit ? true : false))|| glueJobAPILoading}
            />
            {/* 
            // Display the press enter hint component if only ALL the following conditions are true
            1. User has typed anything in the values field
            2. there is no glue job error being shown 
            3. glue job exists api is not in progress 
            */}
            {value?.typed_value?.label && !glueJobAPILoading && !glueJobExistError && enterHintComponent()}
            {glueJobExistError && value?.label === 'contico_job' && glueJobNotFoundComponent()}
            {glueJobAPILoading && value?.label === 'contico_job' && glueJobLoadingComponent()}

		</>
	)
}

export default FlexicoInput;